// src/components/digital_twin/twin_engine/ui/DataSourcesBar.js
// Where every number in the drawer came from, and which sources failed — so operators can trust
// (or question) what they see.
import React, { memo } from 'react';
import { Box, Flex, HStack, Text, Tooltip } from '@chakra-ui/react';
import { SOURCE_LABELS } from '../twinData';
import { useTwinTokens } from './ui';

const DOT = { ok: 'green.400', empty: 'gray.400', error: 'red.400', skipped: 'transparent' };
const WORD = { ok: 'data', empty: 'no records', error: 'failed' };

function DataSourcesBar({ sources, loading }) {
  const t = useTwinTokens();
  const list = Object.entries(sources).filter(([, s]) => s && s.status !== 'skipped');
  if (!list.length) return null;
  return (
    <Flex px={5} py={2} gap={3} flexWrap="wrap" align="center" borderTopWidth="1px" borderColor={t.border} bg={t.card}>
      <Text fontSize="11px" fontWeight="800" color={t.muted}>SOURCES</Text>
      {list.map(([k, s]) => (
        <Tooltip key={k} hasArrow label={`${SOURCE_LABELS[k] || k}: ${WORD[s.status] || s.status}${s.ms != null ? ` · ${s.ms} ms` : ''}${s.error ? ` · ${s.error}` : ''}`}>
          <HStack spacing={1} cursor="default">
            <Box w="7px" h="7px" borderRadius="full" bg={DOT[s.status]} />
            <Text fontSize="11px" color={t.muted}>{SOURCE_LABELS[k] || k}</Text>
          </HStack>
        </Tooltip>
      ))}
      {loading && <Text fontSize="11px" color="cyan.400">refreshing…</Text>}
    </Flex>
  );
}

export default memo(DataSourcesBar);
